export const sits = {
  //Helper methdods
  swapInner: (id, content) => { document.getElementById(id).innerHTML= content },
  swapTab: content => sits.swapInner('tabcontent', content),
  getForm: id => document.getElementById(id),
  getModalFormId: model => document.getElementById(`edit_${model}Modal`).getElementsByTagName('form')[0].id,
  modalFormHide: id => $(`#${id}Modal`).modal('hide'),
  resetForm: id => sits.getForm(id).reset(),
  addHtmlToPagedContent: html => $('#paged_content > div').append(html),
  replaceForm: (id, html) => sits.getForm(id).innerHTML = html,

  //Form handlers
  handler: {
    createSuccess: (id, html) => {
      sits.resetForm(id)
      sits.modalFormHide(id)
      sits.addHtmlToPagedContent(html)
    },
    createFailure: (id, html) => sits.replaceForm(id, html),

    updateSuccess: (model, html) => {
      sits.resetForm( sits.getModalFormId( model ) )
      sits.modalFormHide( `edit_${model}` );
      document.getElementById( `${model}-header` ).outerHTML = html
    },

    updateFailure: (model, html) => {
      sits.replaceForm( sits.getModalFormId( model ), html )
    }
  }
  
}


